import React, { useRef } from "react";
import { XCircleIcon } from "@heroicons/react/20/solid";

const Field = ({ defaultValues, handlers, config, index = 0 }) => {
  const feildRef = useRef("");

  const { id, key, value } = defaultValues;
  const [onChangeKey, onChangeValue, onRemoveFilter, onBlurColumn] = handlers;

  const fieldKeyRef = useRef(key);
  const fieldValueRef = useRef(value);

  const _OnChangeKey = (e) => {
    fieldKeyRef.current = e.target.value;

    let _id = e.target.id.match(/\d+/)[0];
    onChangeKey({ newValue: fieldKeyRef.current, id: _id });
  };
  const _OnChangeValue = (e) => {
    fieldValueRef.current = e.target.value;

    let _id = e.target.id.match(/\d+/)[0];
    onChangeValue({ newValue: fieldValueRef.current, id: _id });
  };

  const _OnRemoveFilter = (event) => {
    let id = event.currentTarget.id.match(/\d+/)[0];

    onRemoveFilter(id);
  };

  return (
    <div
      className="mb-4 sm:grid sm:grid-cols-4 sm:items-start sm:gap-4  sm:border-gray-200"
      id={id}
      data-felid={config}
    >
      <div className="sm:col-span-2 sm:mt-0">
        <label htmlFor={`key-${id}`} className="p-1 mb-1">
          {config.charAt(0).toUpperCase() + config.slice(1)} Name
        </label>
        <input
          id={`key-${id}`}
          required
          name="start"
          value={fieldKeyRef.current}
          type="text"
          onChange={(e) => _OnChangeKey(e)}
          className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          placeholder={`${config}...`}
        />
      </div>
      <div className="w-full sm:col-span-2 sm:mt-0">
        <label htmlFor={`value-${id}`} className="p-1 mb-1">
          {config.charAt(0).toUpperCase() + config.slice(1)} Value
        </label>
        <div className="sm:col-span-2 sm:mt-0 flex justify-between gap-1 items-center">
          <input
            id={`value-${id}`}
            required
            name="start"
            value={fieldValueRef.current}
            type="text"
            onChange={(e) => _OnChangeValue(e)}
            onBlur={onBlurColumn}
            className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="value..."
          />
          {index > 0 ? (
            <button
              id={`close-btn-${id}`}
              type="button"
              className="h-8 w-8"
              onClick={_OnRemoveFilter}
            >
              <XCircleIcon className="" />
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Field;
